import React, { useEffect, useState } from 'react';
import { bathTubFreebieData } from '../../../Constants/ProductPage';
import { SnackBar } from '../PdpHeader/styled';
import OfferSectionNew from './OfferSectionNew';
import PdpOfferNewDesign from './PdpOfferNewDesign';
import { fireEvent } from '../../../Utils/fireEvent';

function OfferCarousel(props) {
  const {
    offerList,
    productId,
    productPrice,
    couponCodeOffers,
    showNewDiaperVariantUx,
    userType,
  } = props;
  const [showToast, setshowToast] = useState(false);
  const [toastValue, setToastValue] = useState('Apply on checkout!');
  const eventHandler = (data) => {
    fireEvent({
      category: 'clicked_offer_on_pdp',
      support_variable: data.offer_heading ? data.offer_heading : data,
      parent: 'Copy Code',
      term_id: data?.term_id,
    });
    if (data == 'copyCode') {
      setToastValue('Copied successfully');
      setshowToast(true);
    } else if (data?.offer_heading) {
      setToastValue('Apply on checkout!');
      setshowToast(true);
    } else {
      setToastValue('');
      setshowToast(false);
    }
  };
  const showNewSection = productId === 2619 || productId === 2620;
  useEffect(() => {
    if (showToast) {
      setTimeout(() => {
        setshowToast(false);
      }, 2800);
    }
  }, [showToast]);
  return (
    <>
      {showNewSection ? (
        <OfferSectionNew
          offerData={bathTubFreebieData}
          eventHandler={eventHandler}
        />
      ) : (
        <PdpOfferNewDesign
          offerList={offerList}
          eventHandler={eventHandler}
          productId={productId}
          productPrice={productPrice}
          couponCodeOffers={couponCodeOffers}
          showNewDiaperVariantUx={showNewDiaperVariantUx}
          userType={userType}
        />
      )}

      <SnackBar className={showToast ? 'show' : ''}>{toastValue}</SnackBar>
    </>
  );
}

export default OfferCarousel;
